import React from "react";
import "./Navbar.css";

function Navbar() {
  return (
    <nav className="navbar">

      {/* Left Logo */}

      <div className="logo-section">
        {/* <img
          src="https://cdn-icons-png.flaticon.com/512/2921/2921822.png"
          alt="logo"
        /> */}

        <div className="logo-text">
          <h1>Chennai</h1>
          <p>WashCare</p>
        </div>
      </div>

      {/* Center Menu */}

      <ul className="nav-links">

        <li><a href="/">Home</a></li>

        <li><a href="/washing-machine-service">Washing Machine Service</a></li>

        <li><a href="/about">About</a></li>

        <li><a href="/contact">Contact</a></li>

      </ul>

      {/* Right Button */}

      <div className="book-btn">
        <button>Book Now</button>
      </div>

    </nav>
  );
}

export default Navbar;